export default "__VITE_ASSET__CCRhN0Ft__"